export default __webpack_public_path__ + "static/google-1c59b556b31c6a75c09ada663c9a7b7f.png";